<template>
  
    <div class="sm:col-12 md:col-12 lg:col-12">
        <div class="surface-card shadow-2 p-3 border-round-lg mt-2 ml-2 mr-2">
            <div class="flex justify-content-start flex-wrap">
                <div class="flex align-items-center justify-content-center text-xl ml-2">
                    Filter Options
                </div>
                
            </div>
            <div class="flex justify-content-start flex-wrap">
                <div class="flex align-items-center justify-content-center w-full">
                    <div class="col-2">
                        <label class="mt-2">Query:</label>
                        <InputText class="w-full mt-2" v-model="searchQuery" type="text" placeholder="Item name or PO No." />
                    </div>
                  <!-- <div class="col">
                    <label class="mt-2">Order status:</label>
                    <Dropdown class="w-full mt-2" v-model="filterAttrib1" placeholder="Select an option" :options="itemPendingStatus" optionLabel="label" optionValue="id" showClear @change="checkOrderStatus"/>
                  </div> -->
                  <div class="col">
                    <div v-if="!pendingToOrderStatus">
                        <label  class="mt-2">Arrival status:</label>
                        <Dropdown class="w-full mt-2" v-model="arrivalStatus" placeholder="Select an option" :options="arrivalStatusOptions" optionLabel="label" optionValue="id" showClear @change="checkArrivalStatus" />
                    </div>
                  </div>
                  <div class="col">
                    <div v-if="!notRecdStatus">
                        <label >Delivery status:</label>
                        <Dropdown class="w-full mt-2" v-model="filterAttrib2" placeholder="Select an option" :options="itemDeliveryStatus" optionLabel="label" optionValue="id" showClear />
                    </div>
                  </div>
                  <div class="col">
                    <div v-if="!notRecdStatus">
                        <label >Delivery Challan:</label>
                        <Dropdown class="w-full mt-2" v-model="deliveryChallanStatus" placeholder="Select an option" :options="deliveryChallanOptions" optionLabel="label" optionValue="id" showClear />
                    </div>
                  </div>

                  <div class="col-3">
                        <label >Dept PO Date:</label>
                        <!-- <Calendar v-model="poDateRange" selectionMode="range" :manualInput="true" dateFormat="dd/mm/yy" placeholder="Start date - End date" class="w-full mr-2 mt-2"></Calendar> -->

                        <div class="flex">
                            <div class="flex-initial flex align-items-center justify-content-center">
                                <Calendar v-model="poStartDate" :manualInput="true" dateFormat="dd/mm/yy" placeholder="Start date" class="w-full mr-2 mt-2"></Calendar>
                            </div>
                            <div class="flex-initial flex align-items-center justify-content-center">
                                <Calendar v-model="poEndDate" :manualInput="true" dateFormat="dd/mm/yy" placeholder="End date" class="w-full mr-2 mt-2"></Calendar>
                            </div>
                        </div>
                    </div>
                  <!-- <div class="col">
                    <div>
                        <label >Cancel/Surrender status:</label>
                        <Dropdown class="w-full mt-2" v-model="filterAttrib3" placeholder="Select an option" :options="itemCancelStatus" optionLabel="label" optionValue="id" showClear/>
                    </div>
                  </div> -->

                  <!-- <div class="col">                    
                    <label >Category:</label>
                    <Dropdown class="w-full mt-2" v-model="selectedCategory" placeholder="Select an option" :options="categories" optionLabel="label" optionValue="key" showClear/>
                  </div> -->

                  <div class="col">
                    <div class="flex">
                        <div class="flex-initial flex align-items-center justify-content-center w-full mt-4">
                            <Button label="Search" raised text severity="success" class="w-full mr-2"  @click="fetchData"/>
                        </div>
                        <div class="flex-initial flex align-items-center justify-content-center w-full mt-4">
                            <Button label="Clear" raised severity="warning" class="w-full " size="small" @click="clearFilter"/>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sm:col-12 md:col-12 lg:col-12">
        <div class="surface-card shadow-2 p-3 border-round-lg mt-2 ml-2 mr-2">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center text-xl ml-2">
                    Items Report
                </div>
                <div class="flex align-items-center justify-content-center text-xl mr-2 mb-2">

                    <Button label="Generate CS" :icon="loaderIcon" raised size="small" class="mr-3" style="background-color:#6DBAAB; border-color:#6DBAAB" @click="generateCs"/>

                    <Button label="Download report" raised  size="small" style="background-color:#B46076; border-color:#B46076" @click="exportCSV" v-tooltip.top="'Excel format'"/>
                </div>
            </div>

                    <div class="field col">
                        <DataTable ref="deptItems" :value="filteredItems" 
                        stripedRows size="small" 
                        showGridlines 
                        :loading="tableLoading" v-model:filters="filters" 
                        :exportFilename="exportableFileName"
                        filterDisplay="menu" 
                        tableStyle="min-width: 50rem; max-width:100%" 
                        dataKey="id" 
                        paginator :rows="100" :rowsPerPageOptions="[10, 20, 50, 100, 200, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        scrollable scrollHeight="400px" 
                        :globalFilterFields="['cancel_surrender', 'order_status', 'category.label', 'piStatus', 'oemPo', 'deliveryStatus', 'pendingReceival', 'pendingDelivery']" 
                        @filter="onFilter" 
                        >

                            <template #empty>
                                <div class="flex align-items-center justify-content-center my-2">
                                    <label class="text-xl font-medium">
                                        No data
                                    </label>
                                </div>
                            </template>    
                            <Column header="Sl No.">
                                <template #body="slotProps">{{1 + slotProps.index}}</template>
                            </Column>
                            <Column field="name" header="Item">
                                <template #body="slotProps">
                                    {{slotProps.data.name}}
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by item" />
                                </template>
                            </Column>
                            <Column field="category.label" header="Category">
                                <template #body="slotProps">
                                    {{slotProps.data.category.label}}
                                </template>
                                <template #filter="{ filterModel }">
                                    <Dropdown v-model="filterModel.value" :options="categories" placeholder="Select Category" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                                        <template #option="slotProps">
                                            {{slotProps.option}}
                                        </template>
                                    </Dropdown>
                                </template>
                            </Column>
                            <Column field="deptPo" header="Order No.">
                                <template #body="slotProps">
                                    {{slotProps.data.deptPo}}
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by Order No." />
                                </template>
                            </Column>
                            <Column field="deptPoDate" header="Order date"></Column>
                            <Column field="packing" header="Packing"></Column>
                            <Column field="rate" header="Rate">
                                <template #body="slotProps" >
                                    {{formatCurrency(slotProps.data.rate)}}
                                </template>
                            </Column>
                            <Column field="quantity" header="Quantity">
                                <template #body="slotProps" >
                                    {{formatNumber(slotProps.data.quantity)}}
                                </template>
                            </Column>
                            <Column field="sub_total" header="Sub-Total (Incl-GST)">
                                <template #body="slotProps" >
                                    {{formatCurrency(slotProps.data.sub_total)}}
                                </template>
                            </Column>
                            <Column field="cancel_surrender" header="Cancel/Surender" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                                <template #body="slotProps">
                                    <Tag :value="slotProps.data.cancel_surrender" :severity="cancelSurrenderSeverity(slotProps.data.cancel_surrender)" ></Tag>
                                </template>
                                <template #filter="{ filterModel }">
                                    <Dropdown v-model="filterModel.value" :options="cancelSurrenderOptions" placeholder="Select One" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                                        <template #option="slotProps">
                                            <Tag :value="slotProps.option" :severity="cancelSurrenderSeverity(slotProps.option)" />
                                        </template>
                                    </Dropdown>
                                </template>
                            </Column>

                            <Column header="Order Status" field="order_status" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                                <template #body="slotProps">
                                    <Tag :severity="getSeverity(slotProps.data.order_status)" :value="slotProps.data.order_status"></Tag>
                                </template>
                                <template #filter="{ filterModel }">
                                    <Dropdown v-model="filterModel.value" :options="orderStatusOptions" placeholder="Select One" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                                        <template #option="slotProps">
                                            <Tag :value="slotProps.option" :severity="getSeverity(slotProps.option)" />
                                        </template>
                                    </Dropdown>
                                </template>
                            </Column>
                            <Column field="oemPo" header="OEM PO" >
                                <template #body="slotProps">
                                    {{ slotProps.data.oemPo }}
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by OEM" />
                                </template>
                            </Column>
                            <Column field="oemPoDate" header="OEM PO Date" >
                                <template #body="slotProps">
                                    {{ slotProps.data.oemPoDate }}
                                </template>
                            </Column>
                            
                            <Column field="orderedQuantity" header="Ordered Qty" >
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.orderedQuantity) }}
                                </template>
                            </Column>
                            <Column field="oemRate" header="OEM Rate" >
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.oemRate) }}
                                </template>
                            </Column>
                            <Column field="oemGst" header="OEM GST(%)" >
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.oemGst) }}
                                </template>
                            </Column>
                            
                            <Column header="PI Status" field="piStatus" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                                <template #body="slotProps">
                                    <Tag :severity="piSeverity(slotProps.data.piStatus)" :value="slotProps.data.piStatus"></Tag>
                                </template>
                                <template #filter="{ filterModel }">
                                    <Dropdown v-model="filterModel.value" :options="piOptions" placeholder="Select One" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                                        <template #option="slotProps">
                                            <Tag :value="slotProps.option" :severity="piSeverity(slotProps.option)" />
                                        </template>
                                    </Dropdown>
                                </template>
                            </Column>

                            <Column field="totalReceived" header="Total Recd" >
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.totalReceived) }}
                                </template>
                            </Column>
                            
                            <Column header="Received" > 
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.totalReceived>0">
                                        <Button label="Recd" size="small" icon="pi pi-window-maximize" @click="fetchRecdStock(slotProps.data)" />
                                    </div>
                                    <div v-else-if="slotProps.data.totalReceived==0">
                                        <label >N/A</label>
                                    </div>
                                </template>
                            </Column> 

                            <Column header="Pending Receival" field="pendingReceival" dataType="numeric" style="min-width: 10rem">
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.pendingReceival) }}
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputNumber v-model="filterModel.value" />
                                </template>
                            </Column>

                            <Column header="Delivery Status" field="deliveryStatus" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                                <template #body="slotProps">
                                    <Tag :severity="deliverySeverity(slotProps.data.deliveryStatus)" :value="slotProps.data.deliveryStatus"></Tag>
                                </template>
                                <template #filter="{ filterModel }">
                                    <Dropdown v-model="filterModel.value" :options="deliveryOptions" placeholder="Select One" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                                        <template #option="slotProps">
                                            <Tag :value="slotProps.option" :severity="deliverySeverity(slotProps.option)" />
                                        </template>
                                    </Dropdown>
                                </template>
                            </Column>
                            <Column field="totalDelivered" header="Delivered" >
                                <template #body="slotProps">
                                    <div>
                                        {{ formatNumber(slotProps.data.totalDelivered) }}
                                    </div>
                                </template>
                            </Column>
                            <Column field="pendingDelivery" header="Pending Delivery" dataType="numeric" style="min-width: 10rem">
                                <template #body="slotProps">
                                    <div>
                                        {{ formatNumber(slotProps.data.pendingDelivery) }}
                                    </div>
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputNumber v-model="filterModel.value" />
                                </template>
                            </Column>
                            <Column field="" header="Delivery Details" >
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.totalDelivered > 0">
                                        <Button icon="pi pi-window-maximize" size="small" raised severity="success" @click="getDeliveryChallanDetails(slotProps.data)"></Button>
                                    </div>
                                    <div v-else>
                                        N/A
                                    </div>
                                </template>
                            </Column>
                        </DataTable>

                    </div>
        </div>

        <CsDialogComponent v-if="csComponent" :data="csData" :visibility="csComponentVisibility" @close-dialog="closeCsDialog"></CsDialogComponent>
    </div>

    <Dialog :visible="recdStockDialog" id="newPaymentDialog" modal :header="recdStockHeader" :closable="false" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" >

        <div class="flex">
            <div class="flex-initial flex align-items-center justify-content-center">
                <DataTable :value="recdDetailsArr" 
                        stripedRows size="small" 
                        showGridlines 
                        :loading="recdStockLoader"  
                        tableStyle="min-width: 57rem; max-width:57rem" 
                        dataKey="id" 
                        paginator :rows="100" :rowsPerPageOptions="[10, 20, 50, 100, 200, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        >

                        <template #empty> 
                            <div class="flex justify-content-center flex-wrap">
                                No data
                            </div>    
                        </template>

                        <Column header="Sl No" style="width:5%;" >
                            <template #body="slotProps">
                                {{ slotProps.index + 1 }}
                            </template>
                        </Column>
                        <Column field="quantity" header="Quantity" >
                            <template #body="slotProps">
                                {{ formatNumber(slotProps.data.quantity) }}
                            </template>
                        </Column>
                        <Column field="date" header="Date" >
                            <template #body="slotProps">
                                {{ slotProps.data.date }}
                            </template>
                        </Column>
                        <Column field="" header="Recd At" >
                            <template #body="slotProps">
                                <div v-if="slotProps.data.store">
                                    {{ slotProps.data.store }}
                                </div>
                                <div v-if="slotProps.data.location">
                                    {{ slotProps.data.location }}
                                </div>
                            </template>
                        </Column>

                    </DataTable>
            </div>
        </div>
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center">
                <div>
                    Total Qty: 
                    <label class="font-semibold">
                        {{formatNumber(totalRecdQty)}}
                    </label>
                </div>
            </div>
            <div class="flex align-items-center justify-content-center">
                <Button size="small" label="Close" severity="secondary" raised text @click="recdStockDialog=false"></Button>
            </div>

        </div>

        <!-- <template #footer>
        </template> -->

    </Dialog>

    <Dialog :visible="deliveryDetails" modal :header="deliveryDetailsHeader" :closable="false" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" >
        <div class="flex">
            <div class="flex-initial flex align-items-center justify-content-center">
                <DataTable :value="recdDetailsArr.challans" 
                        stripedRows size="small" 
                        showGridlines 
                        :loading="recdStockLoader"  
                        tableStyle="min-width: 57rem; max-width:57rem" 
                        dataKey="id" 
                        paginator :rows="100" :rowsPerPageOptions="[10, 20, 50, 100, 200, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        >

                        <template #empty> 
                            <div class="flex justify-content-center flex-wrap">
                                No data
                            </div>    
                        </template>

                        <Column header="Sl No" style="width:5%;" >
                            <template #body="slotProps">
                                {{ slotProps.index + 1 }}
                            </template>
                        </Column>
                        <Column field="location" header="Location" >
                            <template #body="slotProps">
                                {{ slotProps.data.location }}
                            </template>
                        </Column>
                        <Column field="challaNo" header="DC No." >
                            <template #body="slotProps">
                                {{ slotProps.data.challaNo }}
                            </template>
                        </Column>
                        <Column field="quantity" header="Quantity" >
                            <template #body="slotProps">
                                {{ formatNumber(slotProps.data.quantity) }}
                            </template>
                        </Column>
                        <Column field="bill" header="Bill" >
                            <template #body="slotProps">
                                {{ slotProps.data.bill }}
                            </template>
                        </Column>
                    </DataTable>
            </div>
        </div>

        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center">
                <div>
                    Total Qty: 
                    <label class="font-semibold mr-2">
                        {{formatNumber(recdDetailsArr.totalQty)}}
                    </label>

                    Delivered: 
                    <label class="font-semibold mr-2">
                        {{formatNumber(recdDetailsArr.delivered)}}
                    </label>

                    Pending Give Out: 
                    <label class="font-semibold mr-2">
                        {{formatNumber(recdDetailsArr.pendingGiven)}}
                    </label>
                </div>
            </div>
            <div class="flex align-items-center justify-content-center">
                <Button size="small" label="Close" severity="secondary" raised text @click="deliveryDetails=false"></Button>
            </div>
        </div>
        
        <!-- <template #footer>
            <div class="flex justify-content-end flex-wrap">                
                <div class="flex align-items-center justify-content-center">
                    <Button size="small" label="Close" severity="secondary" raised text @click="deliveryDetails=false"></Button>
                </div>

            </div>
        </template> -->

    </Dialog>

</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { deptOrderItemsList, getCategories, fetchCsData, fetchStockRecdDetails, fetchItemDeliveryLocationDetails } from '@/services/apiService'
import Tag from 'primevue/tag'
// import OverlayPanel from 'primevue/overlaypanel'
import Calendar from 'primevue/calendar'
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import CsDialogComponent from './csDialogComponent.vue'
import Dialog from 'primevue/dialog'
import InputNumber from 'primevue/inputnumber'

export default {
    components:{
        InputText,
        InputNumber,
        Button,
        Dropdown,
        DataTable,
        Column,
        Tag,
        // OverlayPanel,
        Calendar,
        CsDialogComponent,
        Dialog,
    },
    data(){
        return{
            categories:[],
            columns:[],
            selectedCategory:null,
            filterAttrib1:null,
            itemPendingStatus:[
                {label:'Pending to order', id:0},
                {label:'Ordered', id:1},
            ],
            arrivalStatus:null,
            arrivalStatusOptions:[
                {label:'Not Received', id:0},
                {label:'Received', id:1},
            ],
            filterAttrib2:null,
            itemDeliveryStatus:[
                {label:'Pending delivery', id:0},
                {label:'Fully delivered', id:1},
                {label:'Partially delivered', id:2},
            ],
            filterAttrib3:null,
            itemCancelStatus:[
                {label:'Cancelled', id:1},
                {label:'Surrendered', id:2},
            ],
            deliveryChallanStatus:null,
            deliveryChallanOptions:[
                {label:'Generated', id:1},
                {label:'Not Generated', id:0},
            ],
            deptItemsArr:[],
            filteredItems:[],
            tableLoading:false,
            pendingToOrderStatus:true,
            notRecdStatus:true,
            opData:[],
            poDateRange:[],
            filters:null,
            fileterdList:[],
            cancelSurrenderOptions:['Cancelled', 'Surrendered'],
            orderStatusOptions:['Not Ordered', 'Ordered', 'Partially Ordered'],
            piOptions:['Received', 'Pending'],
            deliveryOptions:['Completed', 'Pending'],
            csComponent:false,
            csData:[],
            csComponentVisibility:false,
            loaderIcon:null,
            exportableFileName:'Items Report',
            searchQuery:null,
            poStartDate:null,
            poEndDate:null,
            recdStockDialog:false,
            recdStockHeader:null,
            recdStockLoader:false,
            recdDetailsArr:[],
            totalRecdQty:0,
            deliveryDetails:false,
            deliveryDetailsHeader:null,
        }
    },
    methods:{
        fetchAllItems(){
            this.tableLoading = true;
            deptOrderItemsList().then((res)=>{                       
                this.deptItemsArr = res.data;
                this.filteredItems = res.data;
                this.tableLoading = false;
                this.calculateTotalValue(this.deptItemsArr);
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.tableLoading = false;
            });
        },
        // checkOrderStatus(){
        //     if(this.filterAttrib1 == 1){
        //         this.pendingToOrderStatus = false;
        //         this.columns = [
        //             {header:'OEM PO', field:'oem_po'},
        //             // {header:'Received', field:'received'},
        //         ];
        //     }
        //     if(this.filterAttrib1 == 0 || this.filterAttrib1 == null){
        //         this.pendingToOrderStatus = true;
        //         this.notRecdStatus = true;
        //         this.arrivalStatus = null;
        //     }
        // },
        checkArrivalStatus(){
            if(this.arrivalStatus == 1){
                this.notRecdStatus = false;
            }
            if(this.arrivalStatus == 0 || this.arrivalStatus == null){
                this.notRecdStatus = true;
                this.filterAttrib2 = null;
            }
        },
        getSeverity(data){
           switch (data) {
                case 'Not Ordered':
                    return 'danger'
                case 'Ordered':
                    return 'success';
                case 'Partially Ordered':
                    return 'warning';
                default:
                    break;
            }
        },
        piSeverity (status){
            switch (status) {
                case 'Pending':
                    return 'warning'
                case 'Received':
                    return 'success';
                default:
                    break;
            }
        },
        deliverySeverity(status){
            switch (status) {
                case 'Pending':
                    return 'warning'
                case 'Completed':
                    return 'success';
                default:
                    break;
            }
        },
        getValue(data){
            switch (data) {
                case 0:
                    return 'Not Ordered'
                case 1:
                    return 'Ordered';
                case -1:
                    return 'Partially Ordered';
                default:
                    break;
            }
        },
        calculateTotalValue(items){
            let sum = 0;
            items.forEach(e => {
                sum += e.rate * e.quantity;
            }); 
            this.$emit('total-value', sum, 0, 0, 0);
        },
        filterItems(){

            var startDate = null;
            var endDate = null;

            if(this.poDateRange[0]!=null && this.poDateRange[1]!=null){
                startDate = this.poDateRange[0];
                endDate = this.poDateRange[1];
            }

            this.tableLoading = true;
            let tmp = [];
            this.deptItemsArr.forEach(e => {

                var deptDate2 = e.deptPoDate.split("-");
                
                var deptPoDate = new Date(deptDate2[2], (deptDate2[1]-1), deptDate2[0]);  
                if(  ( this.filterAttrib1!=null ? ((this.filterAttrib1==0 && e.order_status==0) || (this.filterAttrib1==1 && e.order_status!=0)) : true) && ( this.arrivalStatus!=null ? e.received==this.arrivalStatus : true ) && (this.selectedCategory!=null ? this.selectedCategory==e.category.key : true) && (this.filterAttrib2!=null ? this.filterAttrib2==e.deliveryStatus : true) && (this.deliveryChallanStatus!=null ? (this.deliveryChallanStatus==0 && e.deliveryChallans.length==0) || (this.deliveryChallanStatus==1 && e.deliveryChallans.length>0) : true) && ((startDate!=null && endDate!=null) ? (deptPoDate >= startDate && deptPoDate <= endDate) : true)){                   
                    tmp.push(e);
                }
            });

            this.filteredItems = [];
            this.filteredItems = tmp;
            this.calculateTotalValue(this.filteredItems);
            this.tableLoading = false;            
            
        },
        clearFilter(){
            this.tableLoading = true;

            this.filterAttrib1 = null;
            this.arrivalStatus = null;
            this.filterAttrib2 = null;
            this.deliveryChallanStatus = null;
            this.pendingToOrderStatus = true;
            this.notRecdStatus = true;
            this.selectedCategory = null;
            this.poDateRange = [];
            this.filteredItems = this.deptItemsArr;
            this.searchQuery = null;
            this.calculateTotalValue(this.filteredItems);
            this.tableLoading = false;
        },
        fetchData(){
            const query = {
                q:this.searchQuery,
                poStartDate:this.poStartDate ? this.poStartDate.getFullYear()+'-'+(this.poStartDate.getMonth()+1)+'-'+this.poStartDate.getDate() : null,
                poEndDate:this.poEndDate ? this.poEndDate.getFullYear()+'-'+(this.poEndDate.getMonth()+1)+'-'+this.poEndDate.getDate() : null,
            }

            this.tableLoading = true;
            deptOrderItemsList(query).then((res)=>{
                this.filteredItems = res.data;
                this.tableLoading = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        async fetchRecdStock(data) {            
            if(!data || !data.id){
                return this.showErrorToast({message:'Data is not defined!'});
            }
            
            try {       
                this.recdDetailsArr = [];
                this.recdStockHeader = 'Recd Details: '+data.name;
                this.recdStockDialog = true;
                this.recdStockLoader = true;

                const response = await fetchStockRecdDetails(data.oemItemId);
                
                this.recdStockLoader = false;
                this.recdDetailsArr = response.data;
                this.totalRecdQty = this.getTotalQty(this.recdDetailsArr);
            } catch (error) {
                this.recdStockLoader = false;
                this.showErrorToast(error.response);
            }            

        },
        getDeliveryChallanDetails(item){
            this.recdStockLoader = true;
            fetchItemDeliveryLocationDetails(item.oemItemId).then((res)=>{
                this.recdDetailsArr = res.data;
                this.deliveryDetailsHeader = 'Challan Details: '+item.name;
                this.deliveryDetails = true;
                this.recdStockLoader = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.recdStockLoader = false;
            })
        },
        getTotalQty(data){
            return data.reduce((accumulator, current) => accumulator + current.quantity, 0);
        },
        exportCSV() {
            this.$refs.deptItems.exportCSV();
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        formatNumber(value) {
            return value.toLocaleString('en-IN');
        },
        formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits:2 });
        },
        cancelSurrenderSeverity(e){
            switch (e) {
                case 'Cancelled':
                    return 'danger';
                case 'Surrendered':
                    return 'warning';
                default:
                    return 'success';
            }
        },
        cancelSurrenderValue(e){        
            switch (e) {
                case 0:
                    return 'Active';
                case 1:
                    return 'Cancelled';
                case 2:
                    return 'Surrendered';
                default:
                    break;
            }
        },
        onFilter(event){
            this.fileterdList = event.filteredValue;
        },
        generateCs(){
            this.loaderIcon = 'pi pi-spin pi-spinner';
            const ids = this.fileterdList.map(item => item.id);
            fetchCsData(ids).then((res)=>{              
                this.csData = res.data.data;
                this.csComponentVisibility = true;
                this.csComponent = true;
                this.loaderIcon = null;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.loaderIcon = null;
            });
        },
        closeCsDialog(){
            this.csComponent = false;
            this.csComponentVisibility = false;
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                deptPo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                packing: { value: null, matchMode: FilterMatchMode.IN },
                cancel_surrender: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                order_status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                'category.label': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                piStatus: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                oemPo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                deliveryStatus: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                pendingReceival: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                pendingDelivery: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            };
        },
    },
    created() {
        this.initFilters();
    },
    mounted(){
        getCategories().then((response)=>{
            response.data.map((category) => {
                this.categories.push(category.label);
            });  
        }).catch((error)=>{
            this.showErrorToast(error.response.data)
        });
    // this.fetchAllItems();

    }
}
</script>

<style>

</style>